export const validateAsOptionalGtOne = (value: any) => {
  if (typeof value === 'number' && value < 1) {
    return 'Geben Sie eine positive Wert ein';
  }

  return true;
};
